{
  "exitAppPromptTitle": "Vuoi uscire dal portale di analisi?",
  "exitAppPromptMessage": "Stai per uscire da FarmHQ e aprire il portale di analisi di FarmHQ in un browser Web esterno."
}
